/*
 * Project: BookingEngine
 * Module: components/common/ShareEmail.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';
import ReactTimeout from 'react-timeout';

import { connect } from 'react-redux';
import { isValidEmail } from '../../utils/Generic';
import { sendGTMEvents } from '../../actions/Booking';

class ShareEmail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonClicked: false,
      emailError: '',
      newShareEmail: '',
      emailList: [],
      activeSelection: false,
      sendingMails: false,
    };
    this.textInput = React.createRef();
  }

  onSendEmails() {
    const { emailList } = this.state;
    const inputEmail = this.inputValue();
    if (emailList.length > 0 || (isValidEmail(inputEmail) && this.validateEmail(inputEmail))) {
      this.setState({ buttonClicked: true, sendingMails: true });
      return this.props.onSendEmails(emailList);
    }
    this.setState({ buttonClicked: true });
    return null;
  }

  inputValue() {
    if (this.textInput) {
      return this.textInput.current.defaultValue.toLowerCase();
    }
    return '';
  }

  addedMailsList() {
    return (
      <ul className="demail-list">
        {this.state.emailList.map((email, index) => (
          <li key={email + index} className={`demail-item ${isValidEmail(email) ? '' : 'invalid'}`}
              onClick={() => this.deleteMail(index)}>
            {email}
            <div className="demail-item__close" />
          </li>
        ))}
      </ul>
    );
  }

  showContent() {
    const { activeSelection } = this.state;
    this.setState({ activeSelection: !activeSelection });
  }

  deleteMail = (index) => {
    const otherEmails = this.state.emailList.filter((item, itemIndex) => itemIndex !== index);
    this.setState({ emailList: otherEmails });
  };

  validateEmail = (email) => {
    const validRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}$/igm;
    return validRegex.test(email);
  }

  watchBreakerKey(event) {
    let newEmail = event.target.value.toLowerCase();
    this.setState({ newShareEmail: newEmail });
    const isBreakerKey = /.+(,|\s)$/.test(newEmail); // we will split the mail if it ends with comma or space
    if (isBreakerKey) {
      newEmail = newEmail.substring(0, newEmail.length - 1);
      this.addEmail(newEmail);
    }
  }

  addEmail(newEmail) {
    const isValid = isValidEmail(newEmail) && this.validateEmail(newEmail);
    const repeatedMail = this.state.emailList.find((email) => email === newEmail);
    if (isValid && !repeatedMail) {
      this.setState({
        emailList: [...this.state.emailList, newEmail],
        newShareEmail: '',
        emailError: '',
      });
      this.props.sendGTMEvents([{ event: 'ShareLink-Add' }]);
    } else if (repeatedMail) {
      this.setState({
        emailError: this.context.t('Email is repeated'),
      });
    } else {
      this.setState({
        emailError: this.context.t('Invalid email'),
      });
    }
  }

  renderErrorMessage(msg) {
    return (
      <div className="share-item__text share-item--error">
        {msg}
      </div>
    );
  }

  renderErrorMessages() {
    const { emailError, buttonClicked, emailList } = this.state;
    if (emailError) {
      return this.renderErrorMessage(emailError);
    }
    if (buttonClicked && emailList.length === 0) {
      return this.renderErrorMessage(this.context.t('Please add at least one e-mail address'));
    }
    return null;
  }

  renderEmailInput() {
    return (
      <div className="main-content email-input group-email">
        <input id="new-email" type="text" name="email-list" placeholder={this.context.t('Add email')}
               className="email-input-simple" value={this.state.newShareEmail} ref={this.textInput}
               onChange={(ev) => this.watchBreakerKey(ev)} />
        <button
          type="button"
          className="btn btn-primary btn-sm ml-1 add"
          onClick={() => this.addEmail(this.state.newShareEmail)}
        >
          {this.context.t('Add email')}
        </button>
        {this.state.emailList.length > 0 && <button
          type="button"
          className="btn btn-primary btn-sm ml-1 send"
          onClick={() => this.onSendEmails()}
        >
          {this.state.sendingMails ? this.context.t('Sending...') : this.context.t('Send')}
        </button>}
      </div>
    );
  }

  render() {
    const { activeSelection } = this.state;
    return (
      <section className="share-item share-email">
        <header className="d-flex" onClick={() => this.showContent()}>
          <div className="share-item__icon">
            <i className="fa fa-envelope-o" aria-hidden />
          </div>
          <div className="share-item__text">
            {this.context.t('Send by mail')}
          </div>
        </header>
        <div className={`share-item__content ${activeSelection ? '' : 'd-none'}`}>
          <div className="text-dark-gray mb-1">
            <small>{this.context.t('Enter one or more email addresses')}</small>
          </div>
          {this.addedMailsList()}
          {this.renderEmailInput()}
          {this.renderErrorMessages()}
        </div>
      </section>
    );
  }
}

ShareEmail.propTypes = {
  onSendEmails: PropTypes.func.isRequired,
};

ShareEmail.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  sendGTMEvents: (payload) => dispatch(sendGTMEvents(payload)),
});

export default connect(null, mapDispatchToProps)(ReactTimeout(ShareEmail));
